import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import RouterScroll from "./router-scroll";
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <RouterScroll />
      <App />
    </BrowserRouter>
  </React.StrictMode>
)
